// extracted by mini-css-extract-plugin
export default {"TemplateContent":"Setting_TemplateContent__pLxQV","CancelBtn":"Setting_CancelBtn__QsJf2","TemplateData":"Setting_TemplateData__9ba+e","contactInfo":"Setting_contactInfo__A9sAq"};